import { constants, ResponsibleApi } from '@atlas/core';

import { isLimitUpdateOlderThanYear } from 'src/components/SelfRegulationProvider/utils';

const resolveSpentLimitPopupVisibility = async (account, authenticated) => {
  if (!authenticated) return false;

  const data = await ResponsibleApi.getClientLossLimits({
    type: constants.SELF_REGULATION_LIMIT.SPENT,
  });

  return account.spentLimitConfigurationEnabled && isLimitUpdateOlderThanYear(data);
};

export default resolveSpentLimitPopupVisibility;
